import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

import { getAvailablePages } from 'common/utils/utils';

const ClientProfileTabNavigation = ({
  availableRoutes,
  clientProfilePath,
  isExpandedOnMobile = false,
  tabPath,
  tabs,
}) => {
  const processedTabs = useMemo(
    () => getAvailablePages(availableRoutes, tabs),
    [availableRoutes, tabs],
  );

  if (isExpandedOnMobile) return null;

  return (
    <div className="tab-navigator">
      <div className="tabs-list">
        {processedTabs.map(({ link, name }) => (
          <NavLink
            className="tab-list-item"
            key={name}
            to={`${clientProfilePath}/${tabPath}/${link}`}
          >
            <Label message={name} />
          </NavLink>
        ))}
      </div>
    </div>
  );
};

ClientProfileTabNavigation.propTypes = {
  availableRoutes: PropTypes.object.isRequired,
  clientProfilePath: PropTypes.string.isRequired,
  isExpandedOnMobile: PropTypes.bool,
  tabPath: PropTypes.string.isRequired,
  tabs: PropTypes.array.isRequired,
};

export default ClientProfileTabNavigation;
